import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1979e0d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "row mt-3" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = {
  class: "filter-button ml-3",
  id: "dashboard-filters"
}
const _hoisted_5 = {
  id: "filters-dashboard",
  class: "dropdown"
}
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "" }
const _hoisted_8 = { class: "dateTxt" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "metricCountToggle" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "bold cursorPointer" }, "Show Actual", -1))
const _hoisted_12 = { class: "toggle" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "disableRefreshToggle-dashboard",
  class: "cursorPointer",
  style: {"width":"40px"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "toggle-button" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "toggle-tab" })
  ])
], -1))
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"mt-3 scrollBar sevenDaydashboardGrid\" data-v-1979e0d6><table id=\"sevenDaydashboardTable\" class=\"table-hover dashboardTable sevenDaydashboardTable\" style=\"height:auto;\" data-v-1979e0d6><colgroup id=\"sevenDayDashboardColGroupTbl\" data-v-1979e0d6></colgroup><thead id=\"sevenDayDashboardHeaderTbl\" data-v-1979e0d6></thead><tbody id=\"sevenDayDashboardBodyTbl\" data-v-1979e0d6></tbody></table></div>", 1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterGrid = _resolveComponent("FilterGrid")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_DashboardNavbar = _resolveComponent("DashboardNavbar")!
  const _component_ToasterPopup = _resolveComponent("ToasterPopup")!
  const _component_PremiumLaborBreakdown = _resolveComponent("PremiumLaborBreakdown")!
  const _component_DepartmentDetails = _resolveComponent("DepartmentDetails")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                class: "btn btn-primary dropdown-toggle",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showFilter && _ctx.showFilter(...args))),
                "data-bs-toggle": "dropdown",
                id: "filters-dashboard-button",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                role: "button"
              }, "Filters"),
              _createElementVNode("div", {
                class: _normalizeClass(["dropdown-menu", [_ctx.isShowFilterDropdown ? 'filterShow': '' , 'dropdown-menu']])
              }, [
                (_ctx.isShowFilterPanel)
                  ? (_openBlock(), _createBlock(_component_FilterGrid, {
                      key: 0,
                      dashboardConfig: _ctx.dashboardConfig,
                      skillData: _ctx.skills
                    }, null, 8, ["dashboardConfig", "skillData"]))
                  : _createCommentVNode("", true)
              ], 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "left_arrow",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.previousDateRange && _ctx.previousDateRange(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'angle-left'],
                size: "lg"
              })
            ]),
            _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.gridDate), 1),
            _createElementVNode("div", {
              class: "right_arrow",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.nextDateRange && _ctx.nextDateRange(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: ['fas', 'angle-right'],
                size: "lg"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_DashboardNavbar),
            _hoisted_11,
            _createElementVNode("fieldset", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                class: "cmn-toggle cmn-toggle-round",
                id: "disableRefreshToggle-dashboard",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isShowActualCount) = $event)),
                onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onMetricsCountChanges && _ctx.onMetricsCountChanges(...args)))
              }, null, 544), [
                [_vModelCheckbox, _ctx.isShowActualCount]
              ]),
              _hoisted_13
            ])
          ])
        ])
      ]),
      _hoisted_14
    ]),
    (_ctx.isToasterVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createVNode(_component_ToasterPopup, {
            onCloseModal: _ctx.closeToasterPopup,
            msgValue: _ctx.msgValue,
            classFlag: _ctx.classFlag
          }, null, 8, ["onCloseModal", "msgValue", "classFlag"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isPremiumLaborBreakdownVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(_component_PremiumLaborBreakdown, {
            onCloseModal: _ctx.closePremiumLaborBreakdownPopup,
            premLaborBreakdownInput: _ctx.premLaborBreakdownInput,
            isBreakdownfrom7Day: true
          }, null, 8, ["onCloseModal", "premLaborBreakdownInput"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isDepartmentModelVisible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createVNode(_component_DepartmentDetails, {
            onCloseModal: _ctx.closeDepartmentPopup,
            departmentList: _ctx.departmentList,
            headerDetails: _ctx.headerDetails
          }, null, 8, ["onCloseModal", "departmentList", "headerDetails"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}